module.exports = __webpack_public_path__ + "media/images/uz-281d74abf3e99c49989126b4698f3764.png";